"use client";

import { RouteError } from "@/components/errors/routeError.component";

import { QUIZ_PAGE, SHOP_PAGE } from "@/constants/page.constants";

const QuizError = ({ error, reset }: QuizErrorProps) => {
  return (
    <RouteError
      error={error}
      reset={reset}
      route="quiz"
      title="Quiz unavailable"
      description="We couldn't load the quiz right now. Try again or start over to find your recommended system."
      links={[
        { href: QUIZ_PAGE, label: "Start over" },
        {
          href: SHOP_PAGE,
          label: "Continue shopping",
          border: true,
        },
      ]}
    />
  );
};

export default QuizError;

type QuizErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};
